export const clearLocalStorage = (_firstTimeUser?: boolean) => {
  //save snapshots
  const createProjectInfoState = localStorage.getItem("createProjectInfoState");
  const createMaterialInfoState = localStorage.getItem("createMaterialInfoState");
  const projectOverviewInfoState = localStorage.getItem("projectOverviewInfoState");
  const materialsInfoState = localStorage.getItem("materialsInfoState");
  const dashboardInfoState = localStorage.getItem("dashboardInfoState");
  const flowGuideState = localStorage.getItem("flowGuideState");
  const colorMode = localStorage.getItem("gaiup-color-mode");

  const storedVersionNumber = localStorage.getItem("version-number");

  const lcaAdaState = localStorage.getItem("lcada-state");

  const token = localStorage.getItem("carbon0.accessToken");

  //Clear storage
  localStorage.clear();
  //reset states
  if (token) localStorage.setItem("carbon0.accessToken", token);
  localStorage.setItem("lcada-state", "show");

  localStorage.setItem("version-number", storedVersionNumber ? storedVersionNumber : "1.0.0");

  localStorage.setItem("createProjectInfoState", createProjectInfoState ? createProjectInfoState : "show");
  localStorage.setItem("createMaterialInfoState", createMaterialInfoState ? createMaterialInfoState : "show");
  localStorage.setItem("projectOverviewInfoState", projectOverviewInfoState ? projectOverviewInfoState : "show");
  localStorage.setItem("materialsInfoState", materialsInfoState ? materialsInfoState : "show");
  localStorage.setItem("dashboardInfoState", dashboardInfoState ? dashboardInfoState : "show");
  localStorage.setItem("flowGuideState", flowGuideState ? flowGuideState : "show");
  if (colorMode) localStorage.setItem("gaiup-color-mode", colorMode);

  localStorage.setItem("lcada-state", lcaAdaState ? lcaAdaState : "show");
};
